/* eslint-disable import/no-anonymous-default-export */
export default {
  BOOKING_REQUESTS:()=>`/driver/bookings/getBookingRequests`,
  BOOKING_LISTING:()=>`/driver/bookings/getMyBookings`,
  BOOKING_DETAIL:(id)=>`/driver/bookings/getBookingDetail/${id}`,
  UPDATE_STATUS:()=>`/driver/bookings/updateStatus`,
  CREATE_PAYMENT:()=>`/driver/payments/createTransaction`,
  
};
  